import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import {
    ProgressBar,
    ResumePret,
    ResumeAssurance,
    ResumeModalites,
    ResumeDate,
    ClavardageContexte,
    setContexteClavardage
} from '../../components';
import { Grid, Typography, Variant, Police, Spacer } from '../../styles';
import {
    IRenouvellement,
    IResumeOffre,
    ISession,
    ParcoursEmprunteur,
    hasSoumissionAssurance
} from '../../hooks';
import { hasOffreSimulee } from '../../hooks/api/demande/useObtenirResumeApi/Resume.utils';

export interface IValidationProps {
    idDemande: number;
    resumeOffre: IResumeOffre;
    session: ISession;
    renouvellement: IRenouvellement;
}

const useStyles = makeStyles(() => ({
    description: {
        fontSize: '20px !important'
    }
}));

export const Validation: React.FC<IValidationProps> = ({
    idDemande,
    resumeOffre,
    session,
    renouvellement
}) => {
    const [t] = useTranslation(['Validation']);
    const isMartine: boolean =
        session?.typeParcoursEmprunteur ===
        ParcoursEmprunteur.COEMPRUNTEUR_MARTINE;
    const classes = useStyles();

    useEffect(() => {
        setContexteClavardage(ClavardageContexte.VALIDATION);

        return () => {
            // Réinitialisation du contexte de clavardage
            setContexteClavardage(ClavardageContexte.DEFAULT);
        };
    }, []);

    return (
        <Grid>
            <ProgressBar
                subtitle={t('titre')}
                subtitleDataTestId="page_validation_titre"
            />
            <Typography
                variant={Variant.p}
                police={Police.normal}
                className={classes.description}
                dataTestId={'page_validation_instructions'}
                hideMarginBottom
            >
                {t('instructionsDesc')}
            </Typography>
            <Spacer all={5} sm={6} />

            {/* Validation */}
            {/* Validation - type de pret */}
            <ResumePret
                isEditButtonDisplayed={!isMartine}
                isTauxAssuranceDisplayed={true}
                isSoldeSansAssuranceDisplayed={false}
                session={session}
                resumeOffre={resumeOffre}
                isSimplifie={false}
            />

            {/* Validation - assurance */}
            <ResumeAssurance
                idDemande={idDemande}
                resumeOffre={resumeOffre}
                isNoAssuranceDisplayed={true}
                isModalProtectionVisible={false}
                isEditButtonDisplayed={
                    !isMartine &&
                    (!hasOffreSimulee(
                        resumeOffre?.offreChoisie?.typeOffreTarification
                    ) ||
                        hasSoumissionAssurance(
                            resumeOffre?.assurance?.codeAssurance
                        ))
                }
                isAssuranceAdmissible={renouvellement?.pretAdmissibleAssurance}
                assures={
                    // sur un retour assurance on veut prendre les donnee de renouvellement car les infos sont fetch des api d'assurance
                    hasSoumissionAssurance(
                        resumeOffre?.assurance?.codeAssurance
                    )
                        ? renouvellement.assures
                        : resumeOffre?.assurance.listeAssure
                }
                parcoursAssurance={renouvellement.parcoursAssurance}
            />

            {/* Validation - modalites */}
            <ResumeModalites
                isEditButtonDisplayed={!isMartine}
                session={session}
                resumeOffre={resumeOffre}
            />

            {/* Validation - date premier versement (optionel) */}
            <ResumeDate
                isEditButtonDisplayed={!isMartine}
                session={session}
                resumeOffre={resumeOffre}
            />
        </Grid>
    );
};
